import { useEffect, useMemo, useState } from 'react';
import useNoodleApi from '@hooks/useNoodleApi';
import * as tsClient from '@tsClient';
import Header from '@components/DesignLibrary/Header';
import ProgressIndicator from '@/components/ProgressIndicator';
import Spacer from '@components/Spacer';
import { capitalize } from 'lodash';

import s from './CreditReportDetails.module.scss';
import CreditReportResponse from './CreditReportResponse';

type Props = {
  creditReportId: string;
};

const CreditReportDetails: React.FC<Props> = ({ creditReportId }) => {
  const [tab, setTab] = useState('main-debtor');
  const { data: creditReportResponses, getData: getCreditReportResponsesFn } = useNoodleApi(tsClient.creditReportsB2C.getCreditReportResponses);

  useEffect(() => {
    getCreditReportResponsesFn({ creditReportId });
  }, [getCreditReportResponsesFn, creditReportId]);

  const responseSlugs: string[] = useMemo(
    () => creditReportResponses?.map(({ slug }: { slug: string }) => slug).sort((a, _) => (a === 'main-debtor' ? -1 : 1)) ?? [],
    [creditReportResponses],
  );

  return (
    <div className={s.wrapper}>
      <Header
        title="Credit Report"
        tabs={responseSlugs.map(slug => ({
          id: slug,
          label: capitalize(slug.replace('-', ' ')),
          onClick: () => setTab(slug),
          selected: slug === tab,
        }))}
      />
      {creditReportResponses
        ? (
          <CreditReportResponse tab={tab} creditReportResponses={creditReportResponses} />
        )
        : (
          <>
            <Spacer />
            <ProgressIndicator isCentered />
          </>
        )}
    </div>
  );
};

export default CreditReportDetails;
